export enum UniSectionSize {
    default = 'default',
    small = 'small',
    medium = 'medium',
};
